import React from 'react';
import ConfigContext from './config-context';

const withConfig = (Component) => (props) =>
  (
    <ConfigContext.Consumer>
      {(config) => <Component {...props} config={config} />}
    </ConfigContext.Consumer>
  );

export default withConfig;
